import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// styles used by the others components.
import {
  QuestionLabel,
  Container,
} from '../styles';

// styles local.
import {
  Difficulty,
  RangeRadioContainer,
  Ranges,
  Label,
  Checkbox,
} from './styles';

const RangeQuestionType = (props) => {
  const {
    questionOptions,
    label,
    leftLabel,
    rightLabel,
    index,
    optionAnswers,
  } = props;

  const questionOptionsSorted = useMemo(() => _.sortBy(questionOptions, (option) => parseInt(option.label, 10)), [questionOptions]);

  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Rating Scale)`}</QuestionLabel>

      <Ranges>
        {_.map(questionOptionsSorted, (option) => (
          <RangeRadioContainer>
            <Checkbox
              radio
              key={option.id}
              label={option.label}
              value={option.id}
              checked={!_.isEmpty(optionAnswers) && optionAnswers.find((optionAnswer) => optionAnswer === option.id)}
              disabled
            />
          </RangeRadioContainer>
        ))}
      </Ranges>

      <Difficulty>
        <Label>{leftLabel}</Label>
        <Label>{rightLabel}</Label>
      </Difficulty>
    </Container>
  );
};

RangeQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  rightLabel: PropTypes.string.isRequired,
  leftLabel: PropTypes.string.isRequired,
  index: PropTypes.number,
  optionAnswers: PropTypes.instanceOf(Array),
};

RangeQuestionType.defaultProps = {
  index: null,
  optionAnswers: [],
};

export default RangeQuestionType;
